import React, { lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { observer } from "mobx-react";

import theme from "@ikas/components/src/style/theme";

const Auth = lazy(() => import("./auth"));
const Dashboard = lazy(() => import("./dashboard"));
const PartnerPage = lazy(() => import("./partner"));

const App = observer(() => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route path="/auth">
            <Auth />
          </Route>
          <Route path="/partner">
            <PartnerPage />
          </Route>
          <Route path="/">
            <Dashboard />
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
});

export default App;
